import api from "@/configs/axios-config";

/**
 * Migration exchange rate จากระบบเก่า — คู่ขนานกับ migrationService.ts (part migration)
 * แต่เป็นราย supplier ไม่ใช่ราย part (1 supplier = 1 ไฟล์ Excel มีหลาย part ข้างใน)
 */

export type OldExchangeRateSupplierRef = {
  supplier_code: string;
};

/** GET /migration/exchange-rate/old-suppliers → enumerate supplier จาก AMPA.FirstTierSuppliers ที่ part_template_v2_id = 2 */
export const getOldExchangeRateSuppliers = async (): Promise<
  OldExchangeRateSupplierRef[]
> => {
  const res = await api.get<OldExchangeRateSupplierRef[]>(
    "/migration/exchange-rate/old-suppliers",
  );
  return res.data;
};

export type OldExchangeRateCbdFile = {
  /** base64 ของไฟล์ xlsx ที่ backend normalize zip แล้ว (exceljs โหลดได้) */
  fileArray: string;
  fileName: string;
};

/**
 * GET /migration/exchange-rate/old-cbd/{supplierCode}
 * backend: เรียก API เก่าโดยใช้ token จาก header `X-Legacy-Token` → normalize zip → คืน base64
 * error handling เหมือน migrationService.ts::getOldCbdFile — LEGACY_TOKEN_EXPIRED ถ้า token หมดอายุ
 */
export const getOldExchangeRateCbdFile = async (
  supplierCode: string,
  legacyToken: string,
): Promise<OldExchangeRateCbdFile> => {
  const res = await api.get<OldExchangeRateCbdFile>(
    `/migration/exchange-rate/old-cbd/${supplierCode}`,
    { headers: { "X-Legacy-Token": legacyToken } },
  );
  return res.data;
};
